(function () {
    'use strict';

    var luminaQuestionnaireServices = angular.module('luminaQuestionnaireServices');

    luminaQuestionnaireServices.factory('returnUrlSanitise', ['luminaEnv', function (luminaEnv) {
        function isLuminaUrl(url, defaultValue) {
            if (url === 'current') {
                // Allow the "constant" value, gets replaced in auth code by the current absolute url
                return url;
            }

            // Remove anything after /, #, or ?
            var givenDomain = url.replace('https://', '')
                .replace('http://', '')
                .split('/')[0]
                .split('#')[0]
                .split('?')[0];
            if (!givenDomain) {
                return defaultValue;
            }
            givenDomain = givenDomain.toLowerCase();
            // Any of the following are valid:
            // - luminalearning.com
            // - a subdomain of luminalearning.com
            // - lumina-nonprod.com
            // - a subdomain of lumina-nonprod.com
            // - localhost

            var regexTests = luminaEnv.whiteListedReturnUrlDomains.map(function (whiteListedDomain) {
                return new RegExp('^' + whiteListedDomain + '$');
            });

            // Always allow any luminalearning.com/lumina-nonprod.com subdomain/domain
            var regexDomainTests = [
                /^(.*\.)?luminalearning\.com$/,
                /^(.*\.)?lumina-nonprod\.com$/,
            ]
                // As well as the whitelisted returnUrls as specified in luminaEnv
                .concat(regexTests);

            var isValid = regexDomainTests.filter(function (regexTest) {
                return regexTest.test(givenDomain);
            }).length > 0;

            return isValid ? url : defaultValue;
        }

        // Returns the sanitised url (replaces things like backslashes with forward slashes),
        // or the default value that is given on failure. If no defaultValue provided, false is returned
        return function (url, defaultValue) {
            if (typeof defaultValue === 'undefined') {
                defaultValue = false;
            }
            try {
                // Decode given return URL, and replace all backslashes with forward slashes
                url = decodeURI(url).replace(/\\/g, '/');
            } catch (e) {
                return defaultValue;
            }

            return isLuminaUrl(url, defaultValue);
        }
    }]);

})();
